import { css } from '@emotion/react'
import { Flow, Heading, Icon, Tag, Theme, useTheme } from 'bold-ui'
import { Ellipsis } from 'components/Ellipsis'
import { TipoDomicilioEnum, TipoLocalizacaoEnum } from 'graphql/types.generated'
import { TipoImovelListModel } from 'view/visualizacaoTerritorial/model'
import { getImovelEnderecoFormatado } from 'view/visualizacaoTerritorial/utils/visualizacaoTerritorialUtils'

import { TerritorioMapaImovelModel } from '../model-territorioMapa'
import { getImovelModalHeaderTags } from '../utils-territorioMapa'

interface PinoTerritorioModalHeaderProps {
  imovel: TerritorioMapaImovelModel
  tipoLocalizacao: TipoLocalizacaoEnum | null
  tipoDomicilio: TipoDomicilioEnum | null
  numeroMoradores: number | null
  dataUltimaVisita: LocalDate | null
  tipoImovelIcon: TipoImovelListModel
}

export function PinoTerritorioModalHeader(props: Readonly<PinoTerritorioModalHeaderProps>) {
  const { imovel, numeroMoradores, tipoLocalizacao, tipoDomicilio, dataUltimaVisita, tipoImovelIcon } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const { HeaderIcon, tooltip: tipoImovelText } = tipoImovelIcon

  const tags = getImovelModalHeaderTags(
    imovel.tipoImovel ?? null,
    tipoDomicilio,
    tipoLocalizacao,
    numeroMoradores,
    dataUltimaVisita,
    imovel.possuiOutrosProfsVinculados ?? false
  )

  return (
    <Flow direction='horizontal' gap={0.75}>
      <HeaderIcon css={styles.headerIcon} />
      <Flow direction='vertical' gap={0.5}>
        <Flow direction='vertical' gap={0}>
          <Heading level={5}>{tipoImovelText}</Heading>
          <Heading level={2}>
            {getImovelEnderecoFormatado({
              logradouro: imovel.logradouro ?? undefined,
              nomeTipoLogradouro: imovel.tipoLogradouro?.nome ?? undefined,
              numero: imovel.numero ?? undefined,
              complemento: imovel.complemento ?? undefined,
              nomeInstituicaoPermanencia: imovel.nomeInstituicaoPermanencia ?? undefined,
            })}
          </Heading>
        </Flow>
        <div css={styles.tagsRow}>
          {tags.map((tag) => (
            <Tag key={tag.label} style={styles.tag}>
              <div css={styles.tagContent}>
                {tag.icon && <Icon size={1} icon={tag.icon} style={styles.tagIcon} />}
                <Ellipsis style={styles.tagLabel}>{tag.label}</Ellipsis>
              </div>
            </Tag>
          ))}
        </div>
      </Flow>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  headerIcon: css`
    width: 3.5rem;
    height: 3.5rem;
  `,
  tagsRow: css`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    min-width: 0;
  `,
  tag: css`
    overflow: hidden;
    flex-shrink: 1;
  `,
  tagContent: css`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
  `,
  tagIcon: css`
    fill: ${theme.pallete.gray.c40};
    flex-shrink: 0;
  `,
  tagLabel: css`
    color: ${theme.pallete.gray.c20};
  `,
})
